import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["action", "formId"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createModelProvider, externalModelUpdate, externalRunBinds, triggerEvent } from "@icg360/rex";
import { turnXmlStringIntoDomDocument } from "./xmlUtils";
export var addressValidation = function addressValidation(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      action = _ref.action,
      formId = _ref.formId;

  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var response, addresses, info, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return action({
                headers: {
                  FullValidation: true
                }
              });

            case 3:
              response = _context.sent;

              if (!(response instanceof Error)) {
                _context.next = 6;
                break;
              }

              throw response;

            case 6:
              addresses = turnXmlStringIntoDomDocument(response);
              info = Array.from(addresses.querySelectorAll("Info"));

              if (info.length) {
                _context.next = 10;
                break;
              }

              throw new Error("Invalid Address");

            case 10:
              data = info.reduce(function (acc, item) {
                var _extends2;

                return _extends({}, acc, (_extends2 = {}, _extends2[item.getAttribute("name")] = item.getAttribute("value"), _extends2));
              }, {});
              dispatch(externalModelUpdate({
                data: data,
                formId: formId
              }));
              _context.next = 17;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](0);
              throw new Error("Failed to validate address:  " + _context.t0.message);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 14]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var addressServicingValidation = function addressServicingValidation(_ref3) {
  var action = _ref3.action,
      formId = _ref3.formId,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded);

  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      var response;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return action();

            case 3:
              response = _context2.sent;

              if (!(response instanceof Error)) {
                _context2.next = 6;
                break;
              }

              throw response;

            case 6:
              if (!response.done) {
                _context2.next = 9;
                break;
              }

              dispatch(externalModelUpdate({
                data: response.result.response.property.details,
                formId: formId
              }));
              return _context2.abrupt("return");

            case 9:
              // eslint-disable-next-line no-console
              console.error(JSON.stringify(_extends({
                action: action,
                formId: formId
              }, props, {
                response: response
              }), null, 2));
              throw new Error("unexpected response");

            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2["catch"](0);
              throw new Error("Failed to validate address property:  " + _context2.t0.message);

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 13]]);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
};
export var analysisValidation = function analysisValidation() {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch, getState) {
      var _data$AAL, state, analysisUrl, formId, _createModelProvider, values, response, dataItems, fieldsToRename, data, riskID, lastSubmissionTimestamp, formattedData, key;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              dispatch(triggerEvent({
                eventName: "analysis-validation-started"
              }));
              dispatch(externalRunBinds());
              state = getState();
              analysisUrl = state.rex.config.services.analysisvalidation;
              formId = state.rex.currentForm.id;
              _createModelProvider = createModelProvider(state, {
                type: "JSON",
                onlyTerms: true
              })("default"), values = _createModelProvider.values;
              _context3.next = 9;
              return fetch(analysisUrl, {
                method: "POST",
                credentials: "include",
                headers: {
                  Accept: "application/xml",
                  "Content-Type": "application/json"
                },
                body: JSON.stringify(values)
              }).then(function (res) {
                if (!res.ok) {
                  throw new Error("Error while validating analysis");
                }

                return res.text();
              }).then(function (xmlString) {
                return turnXmlStringIntoDomDocument(xmlString);
              });

            case 9:
              response = _context3.sent;
              dataItems = Array.from(response.querySelectorAll("DataItem"));
              fieldsToRename = ["CoverageA", "CoverageB", "CoverageC", "CoverageD", "TIV", "ConstructionYear", "ConstructionYearRoof", "SquareFootageUnderRoof", "NumberOfStories"];
              data = dataItems.reduce(function (acc, item) {
                var _extends3;

                return _extends({}, acc, (_extends3 = {}, _extends3[item.getAttribute("name")] = item.getAttribute("value"), _extends3));
              }, {});
              riskID = response.querySelectorAll("RiskAnalysis")[0].getAttribute("riskID");
              lastSubmissionTimestamp = response.querySelectorAll("Event")[0].getAttribute("timestamp");
              formattedData = {
                RiskID: riskID,
                AnalysisID: data.ScoringAnalysisID,
                AnalysisURL: analysisUrl,
                AnalysisValidated: 100,
                AAL: (_data$AAL = data.AAL) == null ? void 0 : _data$AAL.replace(/[$,]+/g, ""),
                AnalysisLastSubmissionTime: lastSubmissionTimestamp
              };

              for (key in data) {
                if (fieldsToRename.includes(key)) {
                  formattedData[key + "Analyzed"] = data[key];
                }
              }

              dispatch(externalModelUpdate({
                data: formattedData,
                formId: formId
              }));
              dispatch(externalRunBinds());
              _context3.next = 24;
              break;

            case 21:
              _context3.prev = 21;
              _context3.t0 = _context3["catch"](0);
              throw new Error("Failed to verify risk:  " + _context3.t0.message);

            case 24:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 21]]);
    }));

    return function (_x3, _x4) {
      return _ref5.apply(this, arguments);
    };
  }();
};